module.exports = __webpack_public_path__ + "static/media/Roboto-Regular.f36638c2.ttf";